define(function (require, exports, module) {
    'use strict';

    // function getCookie(cname) {
    //     let name = cname + "=";
    //     let decodedCookie = decodeURIComponent(document.cookie);
    //     let ca = decodedCookie.split(';');
    //     for(let i = 0; i <ca.length; i++) {
    //         let c = ca[i];
    //         while (c.charAt(0) == ' ') {
    //             c = c.substring(1);
    //         }
    //         if (c.indexOf(name) == 0) {
    //             return c.substring(name.length, c.length);
    //         }
    //     }
    //     return "";
    // }

    const UnitCodeAndNumberMap = {
        'ALG': '08',
        'BAH': '01',
        'EGY': '09',
        'FRA': '05',
        'JOR': '02',
        'LON': '03',
        'MIL': '07',
        'NYK': '04',
        'PAR': '06',
        'SAG': '10',
        'TNE': '11',
        'TNN': '12'
    }

    function getUnitNumber() {
        const countryCode = localStorage.getItem('countryCode');
        if(!countryCode) {
            return '00';
        }
        const unitNumber = UnitCodeAndNumberMap[countryCode];
        console.log(UnitCodeAndNumberMap, countryCode, unitNumber);
        return unitNumber;
    }

    function getGeneratedSessionId(pageId) {
        const unitNumber = getUnitNumber();
        const webSessionId = sessionStorage.getItem('userSessionId');
        const tmxSessionId = webSessionId + unitNumber + pageId;
        return tmxSessionId;
    }
	
	function getGeneratedPaymentSessionId(pageId,PaymentDetail) {
        const unitNumber = getUnitNumber();
        const webSessionId = sessionStorage.getItem('userSessionId');
		const PaymentDetailFix = PaymentDetail.replaceAll(/[^a-z0-9_-]/gi, 'M');
        const tmxSessionId = webSessionId + PaymentDetailFix + unitNumber + pageId;
        return tmxSessionId;
    }

    function getGeneratedPreLoginSessionId(pageId, loginUsername, loginPassword) {
        const unitNumber = '00';
        const partOne = "a20e4a88-c1b2-4dca";
        const partTwo = "850c-40d3643b74c8";

        const decodedUsername1 = loginUsername.replaceAll(/[~`!@#$%^&*()+={}\[\];:\'\"<>.,\/\\\?\-_|]/g, '_');
        const decodedPassword1 = loginPassword.replaceAll(/[~`!@#$%^&*()+={}\[\];:\'\"<>.,\/\\\?\-_|]/g, '_');
		const decodedUsername2 = decodedUsername1.replaceAll(' ', '_');
		const decodedPassword2 = decodedPassword1.replaceAll(' ', '_');
		const decodedUsername = decodedUsername2.replaceAll(/[^a-z0-9_]/gi, 'A');
		const decodedPassword = decodedPassword2.replaceAll(/[^a-z0-9_]/gi, 'A');
        // const today = new Date();
        // const todayFormatted = today.toLocaleDateString('en-GB').split('/').reverse().join('');

        const tmxSessionId = decodedPassword + partOne + decodedUsername + partTwo + unitNumber + pageId;
        return tmxSessionId;
    }

    function getGeneratedLoginSuccessSessionId(pageId) {
        const unitNumber = '00';
        const webSessionId = sessionStorage.getItem('userSessionId');
        const tmxSessionId = webSessionId + unitNumber + pageId;
        return tmxSessionId;
    }
	
	function getGeneratedLoginOTPSessionId(pageId,otp) {
        const unitNumber = '00';
        const webSessionId = sessionStorage.getItem('userSessionId');
        const tmxSessionId = webSessionId + otp + unitNumber + pageId;
        return tmxSessionId;
    }

    //@ngInject -- test "ban3nmwg" -- production "2rb7fpwe"
    module.exports = function ($cookies) {
        const tmxProfilerServices = {
            sendLoginTmxProfiler: function (loginUsername, loginPassword) {
                const pageId = "3100";
                const tmxSessionId = getGeneratedPreLoginSessionId(pageId, loginUsername, loginPassword);
                console.log(tmxSessionId);
                wvdj1408.pt("content.bank-abc.com", "2rb7fpwe", tmxSessionId, pageId);
            },
            sendLoginSuccessTmxProfiler: function () {
                const pageId = "3100";
                const tmxSessionId = getGeneratedLoginSuccessSessionId(pageId);
                console.log(tmxSessionId);
                wvdj1408.pt("content.bank-abc.com", "2rb7fpwe", tmxSessionId, pageId);
            },
			sendLoginOTPTmxProfiler: function (otp) {
                const pageId = "3100";
                const tmxSessionId = getGeneratedLoginOTPSessionId(pageId,otp);
                console.log(tmxSessionId);
                wvdj1408.pt("content.bank-abc.com", "2rb7fpwe", tmxSessionId, pageId);
            },
            sendTmxProfiler: function (pageId) {
                const tmxSessionId = getGeneratedSessionId(pageId);
                console.log(tmxSessionId);
                wvdj1408.pt("content.bank-abc.com", "2rb7fpwe", tmxSessionId, pageId);
            },
            sendPaymentTmxProfiler: function (pageId,PaymentDetail) {
                const tmxSessionId = getGeneratedPaymentSessionId(pageId,PaymentDetail);
                console.log(tmxSessionId);
                wvdj1408.pt("content.bank-abc.com", "2rb7fpwe", tmxSessionId, pageId);
            }
        };
        return tmxProfilerServices;

    };
});


//////////////////
// WEBPACK FOOTER
// ./scripts/tmxProfilerService.js
// module id = 9
// module chunks = 0